
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { useRevealAnimation } from "@/hooks/use-reveal-animation";

const HeroSection = () => {
  const isMobile = useIsMobile();
  const heroReveal = useRevealAnimation<HTMLDivElement>();
  
  // Add fade-in effect on initial load
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="bg-gradient-to-br from-sage-50 to-mint-50 py-10 md:py-24">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div 
            ref={heroReveal.ref}
            style={{
              opacity: heroReveal.isVisible ? 1 : 0,
              transform: heroReveal.isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.7s ease-out',
            }}
          >
            <h1 className="mb-4 text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground">
              Your Armpit Health Matters
            </h1>
            <p className="mb-6 text-base md:text-lg text-muted-foreground">
              Discover top-rated products and expert advice for better underarm care. Your journey to healthier, happier armpits starts here.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild variant="default" size={isMobile ? "default" : "lg"} className="button-hover pulse-on-hover bg-primary text-primary-foreground">
                <Link to="/deodorant-quiz">Take the Quiz</Link>
              </Button>
              <Button variant="outline" size={isMobile ? "default" : "lg"} asChild className="button-hover bg-white text-foreground border-border">
                <Link to="/shop">Shop Products</Link>
              </Button>
            </div>
          </div>
          <div 
            className="relative rounded-lg overflow-hidden shadow-xl image-hover mt-6 md:mt-0"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.7s ease-out 0.3s',
            }}
          >
            <img
              src="/lovable-uploads/83739d41-836b-4590-a55c-6f22c6f99829.png"
              alt="Natural armpit care"
              className="w-full h-auto object-cover rounded-lg"
              loading="eager" // Force eager loading for hero image
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
